import { ArrowLeft, ChevronRight } from "lucide-react";
import ModalDeactivateProperty from "../../../components/ModalDeactivateProperty";
import ModalConfirmActivateProperty from "../../../components/ModalConfirmActivateProperty";
import ModalEditDeactivateProperty from "../../../components/ModalEditDeactivateProperty";
import SaveDraftButton from "../../../components/SaveDraftButton";
import {
  FormStack,
  PropertyStepActions,
} from "../../../components/propertyDescription/descriptionUi";
import {
  NextButton,
  RegisterButton,
} from "../../CreateProperty/twStyles";
import { useEditPropertyWizard } from "./EditPropertyWizardContext";
import ClassificationSection from "./description/ClassificationSection";
import ValuesSection from "./description/ValuesSection";
import EditCommissionSection from "./description/CommissionSection";
import GuaranteesSection from "./description/GuaranteesSection";

export default function EditDescriptionStep() {
  const {
    handleActivateModal,
    handleGoToCharacteristicForm,
    handleSaveDraft,
    handleDraftNextFromDescription,
    isDraft,
    isSavingDraft,
    loadingRequest,
    loadingRequestToActivateProperty,
    openModalConfirmActivateProperty,
    openModalDeactivateProperty,
    openModalEditDeactivateProperty,
    params,
    rentData,
    rentReasons,
    setFormOptionSelected,
    setOpenModalConfirmActivateProperty,
    setOpenModalDeactivateProperty,
    setOpenModalEditDeactivateProperty,
  } = useEditPropertyWizard();

  return (
    <div className="w-full min-w-0">
      {!!openModalDeactivateProperty && (
        <ModalDeactivateProperty
          open={openModalDeactivateProperty}
          property={Number(params.id)}
          rentReasons={rentReasons}
          functionToCloseModal={() => setOpenModalDeactivateProperty(false)}
        />
      )}

      {!!openModalConfirmActivateProperty && (
        <ModalConfirmActivateProperty
          open={openModalConfirmActivateProperty}
          isLoading={loadingRequestToActivateProperty}
          functionToActivateProperty={handleActivateModal}
          functionToCloseModal={() => setOpenModalConfirmActivateProperty(false)}
        />
      )}

      {!!openModalEditDeactivateProperty && (
        <ModalEditDeactivateProperty
          open={openModalEditDeactivateProperty}
          data={rentData}
          rentReasons={rentReasons}
          functionToCloseModal={() => setOpenModalEditDeactivateProperty(false)}
        />
      )}

      <FormStack>
        <ClassificationSection />
        <ValuesSection />
        <EditCommissionSection />
        <GuaranteesSection />
      </FormStack>

      <PropertyStepActions
        leading={
          isDraft ? (
            <SaveDraftButton isLoading={isSavingDraft} onClick={handleSaveDraft} />
          ) : (
            <RegisterButton
              type="button"
              className="h-10 py-0"
              onClick={loadingRequest ? () => {} : handleGoToCharacteristicForm}
            >
              <p>{loadingRequest ? "Carregando..." : "Salvar"}</p>
            </RegisterButton>
          )
        }
        trailing={
          <>
            <NextButton
              type="button"
              className="inline-flex h-10 gap-1.5 py-0 [&>svg]:!ml-0"
              onClick={() => {
                setFormOptionSelected("map");
                window.scrollTo(0, 0);
              }}
            >
              <ArrowLeft className="h-4 w-4 text-white" aria-hidden />
              <p>Voltar</p>
            </NextButton>
            <NextButton
              type="button"
              className="inline-flex h-10 gap-1.5 py-0"
              onClick={() => {
                if (isDraft) {
                  handleDraftNextFromDescription?.();
                  return;
                }
                setFormOptionSelected("publication");
                window.scrollTo(0, 0);
              }}
            >
              <p>Próximo</p>
              <ChevronRight className="h-4 w-4 text-white" aria-hidden />
            </NextButton>
          </>
        }
      />
    </div>
  );
}
